import styles from './AmenitiesCard.module.css'

/** Lives in the registration rail, directly under RegistrationCard - Desktop.dc.html's aside is
 *  reg card -> track amenities card -> sponsor slot, in that order, not amenities folded into the
 *  venue section in main. */
export function AmenitiesCard({ amenities }: { amenities: string[] }) {
  if (!amenities.length) return null
  return (
    <div className={styles.card}>
      <div className={styles.label}>Track amenities</div>
      <div className={styles.chips}>
        {amenities.map((a) => (
          <span key={a} className={styles.chip}>
            {a}
          </span>
        ))}
      </div>
    </div>
  )
}
